import React from 'react';
import { useNavigate } from 'react-router-dom';

const Management = () => {
  const navigate = useNavigate();
  
  // Management team data - this would typically come from a database or API
  const managementTeam = [
    { id: 1, name: 'Jim Dinan', title: 'President / CEO / Owner', image: '/images/management/james-dinan.jpg' },
    { id: 2, name: 'Nick Ganem', title: 'Vice President', image: '/images/management/john-smith.jpg' },
    { id: 3, name: 'Michelle Dinan-Cardone', title: 'Executive Administrator', image: '/images/management/sarah-johnson.jpg' },
    { id: 4, name: 'Drew Schroder', title: 'Construction Director', image: '/images/management/mike-rodriguez.jpg' },
    { id: 5, name: 'Sabino Nieto', title: 'Project Director', image: '/images/management/lisa-chen.jpg' },
    { id: 6, name: 'Robert Dustman', title: 'Project Director', image: '/images/management/david-thompson.jpg' },
    { id: 7, name: 'John McIntyre', title: 'Preconstruction Manager/Chief Estimator', image: '/images/management/jennifer-martinez.jpg' },
    { id: 8, name: 'Greg Era', title: 'IT Manager', image: '/images/management/robert-wilson.jpg' },
    { id: 9, name: 'Brandon Sonju', title: 'Service Ops Manager', image: '/images/management/amanda-davis.jpg' },
    { id: 10, name: 'Ken Groll', title: 'Service Manager', image: '/images/management/chris-anderson.jpg' },
    { id: 11, name: 'Brandon Henderson', title: 'BIM Director', image: '/images/management/michelle-brown.jpg' },
    { id: 12, name: 'Scott Kienast', title: 'Safety Director', image: '/images/management/kevin-taylor.jpg' }
  ];

  const handleManagerClick = (managerId) => {
    // Navigate to individual manager page
    navigate(`/management/${managerId}`);
  };

  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['person', 'groups', 'person_search', 'supervisor_account', 'badge', 'account_circle', 'manage_accounts', 'people'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Leadership
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Management Team
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Meet our experienced leadership team driving excellence in mechanical contracting
            </p>
          </div>
        </div>
      </section>

      {/* Management Team Introduction */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Leadership Excellence</h2>
            <p>Our management team brings decades of combined experience in mechanical contracting, engineering, and business operations</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Led by <strong style={{color: 'var(--accent-blue)'}}>Jim Dinan, President and CEO</strong>, our executive team brings decades of combined experience in mechanical contracting, engineering, and business operations. Their vision and leadership have positioned Bel-Aire Mechanical as Arizona's premier mechanical contractor.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Our operational managers oversee daily operations, ensuring projects are completed on time, within budget, and to the highest quality standards. Each member of our leadership team is actively involved in driving excellence across all aspects of our business.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Management Team Group Photo]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                Click on any team member below to learn more about their background, experience, and contributions to Bel-Aire Mechanical's continued success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Management Team Grid */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Meet Our Leadership Team</h2>
            <p>Experienced professionals dedicated to excellence in mechanical contracting</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="management-team-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '2rem'
            }}>
              {managementTeam.map((manager) => (
                <div
                  key={manager.id}
                  onClick={() => handleManagerClick(manager.id)}
                  className="management-card"
                  style={{
                    background: 'var(--white)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: '2px solid transparent',
                    textAlign: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-5px)';
                    e.target.style.boxShadow = '0 8px 30px rgba(0, 104, 166, 0.2)';
                    e.target.style.borderColor = 'var(--accent-blue)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
                    e.target.style.borderColor = 'transparent';
                  }}
                >
                  <div 
                    className="image-placeholder management-card-image" 
                    style={{
                      width: '100%',
                      height: '200px',
                      borderRadius: '8px',
                      marginBottom: '1rem',
                      backgroundImage: `url(${manager.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat'
                    }}
                  >
                    {/* Fallback for missing images */}
                    <div className="management-card-initials" style={{
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(135deg, var(--accent-blue), var(--accent2-red))',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'var(--white)',
                      fontSize: '3rem',
                      fontWeight: 'bold'
                    }}>
                      {manager.name.split(' ').map(n => n[0]).join('')}
                    </div>
                  </div>
                  
                  <h3 className="management-card-name" style={{
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    color: 'var(--accent-blue)',
                    marginBottom: '0.5rem'
                  }}>
                    {manager.name}
                  </h3>
                  
                  <p className="management-card-title" style={{
                    fontSize: '0.9rem',
                    color: 'var(--gray-600)',
                    margin: 0,
                    lineHeight: '1.4'
                  }}>
                    {manager.title}
                  </p>
                  
                  <div className="management-card-cta" style={{
                    marginTop: '1rem',
                    padding: '0.5rem',
                    background: 'var(--secondary-light)',
                    borderRadius: '6px',
                    fontSize: '0.8rem',
                    color: 'var(--accent-blue)',
                    fontWeight: '500'
                  }}>
                    Click to Learn More
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Structure Overview */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Leadership Structure</h2>
            <p>Organized leadership ensuring comprehensive coverage of all business operations</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="leadership-structure-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '1rem'
            }}>
              <div className="leadership-structure-item" style={{
                background: 'var(--white)',
                padding: '1.5rem',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Executive Leadership</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Strategic vision and company direction</p>
              </div>
              <div className="leadership-structure-item" style={{
                background: 'var(--white)',
                padding: '1.5rem',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Operations Management</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Day-to-day operational oversight</p>
              </div>
              <div className="leadership-structure-item" style={{
                background: 'var(--white)',
                padding: '1.5rem',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Project Management</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Experienced project managers</p>
              </div>
              <div className="leadership-structure-item" style={{
                background: 'var(--white)',
                padding: '1.5rem',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Technical Leadership</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Engineering and technical expertise</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Management;
